import { MenuItem } from 'primeng/api';

export const STEPPER_ITEMS: MenuItem[] = [
  { label: 'Select Challenges', routerLink: 'select-challenges' },
  { label: 'Select Solutions', routerLink: 'select-solutions' },
  { label: 'View Summary', routerLink: 'view-summary' },
];
